<div class="form-group">
  <label for="state">
    {{ label | translate }}
    <i *ngIf="isShowRequired" class="fa fa-asterisk form-required" aria-hidden="true"></i>
  </label>
  <ng-select
    class="custom"
    [items]="states"
    [loading]="statesLoading"
    [typeahead]="statesTypeahead"
    [(ngModel)]="selectedState"
    (change)="onChangeState($event)"
    id="state"
    [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
    [clearable]="isClearable"
    (clear)="onClear()"
    [formControl]="stateFc"
  >
    <ng-template ng-option-tmp let-item="item">{{ item.code }} {{ item.description }}</ng-template>
    <ng-template ng-label-tmp let-item="item">{{ item.code }} {{ item.description }}</ng-template>
  </ng-select>
  <app-control-errors [control]="stateFc" [errors]="errors" [isShowHelper]="true"></app-control-errors>
</div>
